<span class="question-circle-span">
	<i *ngIf="!infoStyle" class="far fa-question-circle" [id]="tooltipId"></i>
	<i *ngIf="infoStyle" class="far fa-info-circle" [id]="tooltipId"></i>
</span>

<dx-tooltip
	target="#{{tooltipId}}"
	showEvent="mouseenter"
	hideEvent="mouseleave"
>
	<div *dxTemplate="let data = data; of: 'content'">
		<ng-content></ng-content>
	</div>
</dx-tooltip>
